import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { FormattedMessage, injectIntl } from 'react-intl';
import {
  Form,
  Checkbox,
  // Select,
  Radio,
} from 'antd';
import { observer } from 'mobx-react';
import CommonButton from '../../common/Button';
import Input from '../../common/Input';
// import { themeColors } from '../../../constants/themes';
import { numRegExp } from '../../../constants/validNumberRegExp';
import currencies from '../../../constants/currency.json';

// const { Option } = Select;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 1.1em;
  & > .ant-form-item {
    margin-bottom: 0em;
  }
  & > .ant-form-item:not(:last-child) {
    margin-right: 2em;
  }
  & label {
    margin-bottom: 0px;
    font-weight: normal;
  }
  & .ant-form-item-label {
    padding-bottom: 2px;
  }
  & .ant-form-explain {
    position: absolute;
    white-space: nowrap;
  }
`;

// const LinkButton = styled.a`
//   color: grey;
//   text-decoration: underline;
// `;

@injectIntl
@Form.create()
@observer
class RangedProfitEditForm extends Component {
  getDefaultValues = () => {
    // const { getStrategyDefaultValues, form, type } = this.props;
    // getStrategyDefaultValues(type).then(data => {
    //   form.setFieldsValue(data);
    // });
    // todo add restore defaults
  };

  saveChanges = e => {
    e.preventDefault();
    this.props.form.validateFields(err => {
      if (!err) {
        this.props.saveNewPricing();
      }
    });
  };

  hasErrors = fieldsError => Object.values(fieldsError).some(value => value);

  render() {
    const { form, pricing, intl, isUpdatingAllStore, setIsUpdatingAllStore } = this.props;
    const RadioGroup = Radio.Group;
    const { getFieldDecorator, getFieldsError } = form;
    const symbolStyle = { marginLeft: '5px', fontSize: '16px' };

    return (
      <div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <FormattedMessage id="pricing.pricingName" defaultMessage="Pricing Name" />
          {/* <LinkButton onClick={this.getDefaultValues}> */}
          {/*   {intl.formatMessage({ id: 'prising.getDefaults' })} */}
          {/* </LinkButton> */}
        </div>
        <Row>
          <div className="title2">
            <FormattedMessage id="pricing.rangedProfit" defaultMessage="Ranged Profit" />
          </div>
        </Row>
        <Form layout="vertical" onSubmit={this.saveChanges} hideRequiredMark>
          {pricing.map(pr => (
            <div key={`${pr.minValue}${pr.maxValue}`}>
              <h3>
                {`${currencies[pr.currency].symbol}${pr.minValue}->${currencies[pr.currency].symbol
                  }${pr.maxValue}`}
              </h3>
              <Row>
                <Form.Item
                  label={<FormattedMessage id="common.breakEven" defaultMessage="Break Even" />}
                >
                  {getFieldDecorator(`breakEven${pr.minValue}${pr.maxValue}`, {
                    initialValue: pr.breakEven,
                    rules: [
                      {
                        required: true,
                        message: intl.formatMessage({ id: 'pricing.requiredNumber' }),
                      },
                      {
                        pattern: numRegExp,
                        message: intl.formatMessage({ id: 'pricing.requiredNumber' }),
                      },
                    ],
                  })(
                    <Input
                      width="6em"
                      type="number"
                      onChange={({ target: { value } }) => {
                        pr.setBreakEven(parseFloat(value) || null);
                      }}
                    />,
                  )}
                  <span style={symbolStyle}>%</span>
                </Form.Item>
                <Form.Item label={<FormattedMessage id="common.profit" defaultMessage="Profit" />}>
                  {getFieldDecorator(`profit${pr.minValue}${pr.maxValue}`, {
                    initialValue: pr.profit,
                    rules: [
                      {
                        required: true,
                        message: intl.formatMessage({ id: 'pricing.requiredNumber' }),
                      },
                      {
                        pattern: numRegExp,
                        message: intl.formatMessage({ id: 'pricing.requiredNumber' }),
                      },
                    ],
                  })(
                    <Input
                      width="6em"
                      type="number"
                      onChange={({ target: { value } }) => {
                        pr.setProfit(parseFloat(value) || null);
                      }}
                    />,
                  )}
                </Form.Item>
                <Form.Item style={{ paddingTop: '20px' }}>
                  {getFieldDecorator(`inPercents${pr.minValue}${pr.maxValue}`, {
                    initialValue: pr.inPercents,
                  })(
                    <RadioGroup onChange={({ target: { value } }) => pr.setInPercents(value)}>
                      <Radio value>%</Radio>
                      <Radio value={false}>$</Radio>
                    </RadioGroup>,
                  )}
                </Form.Item>
              </Row>
            </div>
          ))}
          <Row style={{ justifyContent: 'flex-start' }}>
            <Checkbox
              checked={isUpdatingAllStore}
              onClick={() => setIsUpdatingAllStore(!isUpdatingAllStore)}
            >
              <FormattedMessage id="pricing.updateAllListings" defaultMessage="Update All Listings" />
            </Checkbox>
          </Row>
          <Row style={{ justifyContent: 'flex-end' }}>
            <CommonButton
              htmlType="submit"
              type="normal"
              clickHandler={() => { }}
              disabled={this.hasErrors(getFieldsError())}
            >
              <FormattedMessage id="pricing.saveNewPricing" defaultMessage="Save New Pricing" />
            </CommonButton>
          </Row>
        </Form>
      </div>
    );
  }
}

RangedProfitEditForm.propTypes = {
  form: PropTypes.object,
  intl: PropTypes.object,
  pricing: PropTypes.object,
  // sellersAccounts: PropTypes.array,
  // selectedAccountCode: PropTypes.string,
  saveNewPricing: PropTypes.func,
};

export default RangedProfitEditForm;
